import Dashboard from './Dashboard';
import ChangeLog from './ChangeLog';
import Inquiry from './accounts/Inquiry';
import NewAccount from './accounts/NewAccount';
import ViewAccount from './accounts/ViewAccount';
import ViewPastSubmission from './accounts/ViewPastSubmission';
import UpdateProfile from './administrations/UpdateProfile';
import ChangePassword from './administrations/ChangePassword';
import UserGuide from './administrations/UserGuide';
import Keyword from './administrations/Keyword';
import GlobalGuide from './administrations/GlobalGuide';
import User from './administrations/User';
import AddUser from './administrations/AddUser';
import UserGroup from './administrations/UserGroup';
import ClientAlert from './alerts/ClientAlert';
import Cancellation from './cancellations/Cancellation';
import CancellationPending from './cancellations/CancellationPending';
import Hold from './holds/Hold';
import RequestedHold from './holds/RequestedHold';
import PaymentAdjustment from './payments/PaymentAdjustment';
import EnterPayments from './payments/EnterPayments';
import PaymentAdjustmentSubmission from './payments/PaymentAdjustmentSubmission';
import AckReport from './reports/AckReport';
import ActuaryReport from './reports/ActuaryReport';
import CancellationReport from './reports/CancellationReport';
import CashflowReport from './reports/CashflowReport';
import TrustReport from './reports/TrustReport';
import PaymentReport from './reports/PaymentReport';
import InventoryReport from './reports/InventoryReport';
import Mails from './mails/Mails';
import SavedSearch from './reports/SavedSearch';
import EDIUpload from './accounts/EDIUpload';

export {
    Inquiry
    , ClientAlert
    , ViewPastSubmission
    , AckReport
    , ActuaryReport
    , CancellationReport
    , CashflowReport
    , TrustReport
    , Dashboard
    , Hold
    , RequestedHold
    , PaymentAdjustment
    , PaymentReport
    , PaymentAdjustmentSubmission
    , Cancellation
    , CancellationPending
    , InventoryReport
    , UpdateProfile
    , ChangePassword
    , UserGuide
    , Keyword
    , GlobalGuide
    , User
    , AddUser
    , UserGroup
    , NewAccount
    , Mails
    , ViewAccount
    , EnterPayments
    , SavedSearch
    , ChangeLog
    , EDIUpload
};


// WEBPACK FOOTER //
// ./src/app/ui/index.js